/* TurnReportList Messages
 *
 * This contains all the text for TurnReportList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.TurnReportList.header',
    defaultMessage: 'Turn Reports',
  },
  noClosedTurnReports: {
    id: 'app.components.TurnReportList.noClosedTurnReports',
    defaultMessage: 'There are no closed turn reports, yet.',
  },
  noOpenTurnReports: {
    id: 'app.components.TurnReportList.noOpenTurnReports',
    defaultMessage: 'There are no more open turn reports.',
  },
  noMissingTurnReports: {
    id: 'app.components.TurnReportList.noMissingTurnReports',
    defaultMessage: 'There are no more missing turn reports.',
  },
  closedReports: {
    id: 'app.components.TurnReportList.closedReports',
    defaultMessage: 'Closed reports',
  },
  openReports: {
    id: 'app.components.TurnReportList.openReports',
    defaultMessage: 'Open reports',
  },
  missingReports: {
    id: 'app.components.TurnReportList.missingReports',
    defaultMessage: 'Missing reports',
  },
});
